const cleanObject = <T>(object: T) =>
  Object.fromEntries(
    Object.entries(object as Record<string, unknown>).filter(
      ([_, v]) => v || typeof v === "boolean",
    ),
  ) as T;

export default cleanObject;
